import css from 'styled-jsx/css';

export default css`.buoy {
  cursor: pointer;
  content: '';
  display: none;
  opacity: .01;
  overflow: hidden;
  position: fixed;
  right: 0;
  bottom: 50px;
  width: 125px;
  height: 125px;
  margin-bottom: calc(constant(safe-area-inset-bottom) + 10px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 10px);
  transition: opacity .3s, bottom .5s, right .5s, transform .5s;
  z-index: 999; }
  .buoy img {
    width: 105px;
    height: 105px;
    position: absolute;
    bottom: 0;
    left: 0; }
  .buoy.show {
    display: block;
    opacity: 1; }
  @media (min-width: 768px) {
    .buoy {
      bottom: 40px; } }
  .buoy.svg :global(.popbox-container) {
    border-radius: 50%;
    overflow: hidden; }
`